import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Button, Switch } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SaveIcon from '@mui/icons-material/Save';
import palette from 'src/theme/palette';
import ViewOnMapInfo from './viewOnMapInfo';
import { postSettingData } from 'src/ApiServices';
import { id } from 'date-fns/locale';
import { toast, ToastContainer } from 'react-toastify';
import InputLabel from '@mui/material/InputLabel';
import { FormControlLabel } from '@mui/material';

const CompanyInfoTab = ({ tabData = [], typeId }) => {
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const getInitialFormData = () => {
    const dataMap = {};
    tabData.forEach((item) => {
      dataMap[item.key] = {
        id: item.id || '',
        value: item.value || ''
      };
    });

    return {
      company_name: dataMap['company_name'] || { id: '', value: '' },
      agent_name: dataMap['agent_name'] || { id: '', value: '' },
      company_email: dataMap['company_email'] || { id: '', value: '' },
      company_number: dataMap['company_number'] || { id: '', value: '' },
      company_address: dataMap['company_address'] || { id: '', value: '' },
      is_email_on_website: dataMap['is_email_on_website'] || { id: '', value: '0' }
    };
  };

  const [formData, setFormData] = useState(getInitialFormData());

  useEffect(() => {
    setFormData(getInitialFormData());
  }, [tabData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: value
      }
    }));
  };

  const handleEmailSwitch = (e) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      is_email_on_website: {
        ...prev.is_email_on_website,
        value: checked ? '1' : '0'
      }
    }));
  };

  const handleLocationClick = () => {
    setMapModalOpen(true);
  };

  const handleCloseMapModal = () => {
    setMapModalOpen(false);
  };
  const handleSaveSettings = async () => {
    const valueArray = [
      {
        id: formData.company_name.id || null,
        key: 'company_name',
        value: formData.company_name.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.company_name.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      },
      {
        id: formData.agent_name.id || null,
        key: 'agent_name',
        value: formData.agent_name.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.agent_name.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      },
      {
        id: formData.company_email.id || null,
        key: 'company_email',
        value: formData.company_email.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.company_email.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      },
      {
        id: formData.company_number.id || null,
        key: 'company_number',
        value: formData.company_number.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.company_number.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      },
      // {
      //   id: formData.company_whatsapp_number.id || null,
      //   key: 'company_whatsapp_number',
      //   value: formData.company_whatsapp_number.value,
      //   content_type: null,
      //   file: null,
      //   type_id: typeId,
      //   type: 'Company Information',
      //   created_at: formData.company_whatsapp_number.id ? '2025-11-21 06:45:09' : null,
      //   updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      // },
      {
        id: formData.company_address.id || null,
        key: 'company_address',
        value: formData.company_address.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.company_address.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      },
      {
        id: formData.is_email_on_website.id || null,
        key: 'is_email_on_website',
        value: formData.is_email_on_website.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Company Information',
        created_at: formData.is_email_on_website.id ? '2025-11-21 06:45:09' : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      }
    ];

    const finalPayload = {
      type_id: typeId.toString(),
      value: JSON.stringify(valueArray)
    };

    try {
      console.log('Final Payload:', finalPayload);
      const response = await postSettingData(finalPayload);
      if (response) {
        const status = response.status || response.statusCode || 200;
        const data = response.data || response;
        const message = response.message || data.message || 'Settings saved successfully!';

        if (status >= 200 && status < 300) {
          // Success - show exact response message
          toast.success(message, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          console.log('Success Response:', data);
        } else if (status === 401 || status === 403) {
          // Authentication/Authorization errors
          toast.error(message || 'Unauthorized access. Please login again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else if (status === 400) {
          // Validation errors
          toast.error(message || 'Please check your input data.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else if (status === 404) {
          // Not found
          toast.error(message || 'Resource not found.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else if (status >= 500) {
          // Server errors
          toast.error(message || 'Server error. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else {
          // Other errors
          toast.error(message || 'Something went wrong. Please try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        }
      } else {
        // No response object
        toast.error('No response received from server.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      }
    } catch (error) {
      // Network errors or exceptions
      console.error('API Error:', error);

      const errorMessage =
        error.message ||
        (error.response && error.response.data && error.response.data.message) ||
        'Network error. Please check your connection.';

      toast.error(errorMessage, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } finally {
      setLoading(false);
    }
    postSettingData(finalPayload);
  };

  return (
    <Box component="form" noValidate>
      {/* View On Map Modal */}
      <ViewOnMapInfo show={mapModalOpen} onClose={handleCloseMapModal} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Company Name"
            name="company_name"
            value={formData?.company_name?.value}
            onChange={handleInputChange}
            placeholder="Enter company name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Agent Name"
            name="agent_name"
            value={formData?.agent_name?.value}
            onChange={handleInputChange}
            placeholder="Enter agent name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Company Email"
            name="company_email"
            type="email"
            value={formData?.company_email?.value}
            onChange={handleInputChange}
            placeholder="Enter company email"
          />
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
          <Switch
            checked={formData.is_email_on_website.value === '1'}
            onChange={handleEmailSwitch}
            name="is_email_on_website"
            color="primary"
          />
          <InputLabel>Show Email Address on Website</InputLabel>
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            name="company_whatsapp_number"
            value={formData?.company_whatsapp_number?.value}
            onChange={handleInputChange}
            placeholder="Enter WhatsApp number"
          />
        </Grid> */}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Company Contact Number"
            name="company_number"
            value={formData?.company_number.value}
            onChange={handleInputChange}
            placeholder="Enter contact number"
          />
        </Grid>
        {/* <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Company WhatsApp Number"
            name="company_whatsapp_number"
            value={formData?.company_whatsapp_number?.value}
            onChange={handleInputChange}
            placeholder="Enter WhatsApp number"
          />
        </Grid> */}

        {/* Location Section */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Company Address"
            name="company_address"
            value={formData?.company_address?.value}
            onChange={handleInputChange}
            placeholder="Enter company address or use map picker above"
          />

          <Box sx={{ mb: 2, mt: 2 }}>
            <Button startIcon={<LocationOnIcon />} onClick={handleLocationClick} sx={{ mb: 1 }}>
              View Location on Map
            </Button>
            <Typography variant="body2" color="text.secondary">
              Click above to view company location on map
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} container justifyContent="flex-end">
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSaveSettings}
            sx={{
              background: palette.primary.main,
              color: palette.primary.contrastText,
              height: 40,
              '&:hover': { background: palette.primary.dark }
            }}
          >
            Save Settings
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompanyInfoTab;
